import ELK from "elkjs/lib/elk.bundled.js"

export interface LayoutBox {
  readonly id: string
  readonly width: number
  readonly height: number
}

export interface LayoutLink {
  readonly id: string
  readonly source: string
  readonly target: string
}

const elk = new ELK()

/**
 * Layered (Sugiyama) placement via ELK. Returns top-left positions by node id;
 * edges are routed by the renderer.
 */
export async function layeredLayout(nodes: readonly LayoutBox[], links: readonly LayoutLink[], direction: "RIGHT" | "DOWN" = "RIGHT"): Promise<Map<string, { x: number; y: number }>> {
  const result = await elk.layout({
    id: "root",
    layoutOptions: {
      "elk.algorithm": "layered",
      "elk.direction": direction,
      "elk.layered.spacing.nodeNodeBetweenLayers": "96",
      "elk.spacing.nodeNode": "40",
      "elk.layered.nodePlacement.strategy": "BRANDES_KOEPF",
      "elk.layered.crossingMinimization.strategy": "LAYER_SWEEP",
      "elk.separateConnectedComponents": "true",
      "elk.spacing.componentComponent": "64",
    },
    children: nodes.map((n) => ({ id: n.id, width: n.width, height: n.height })),
    edges: links.map((l) => ({ id: l.id, sources: [l.source], targets: [l.target] })),
  })
  const out = new Map<string, { x: number; y: number }>()
  for (const child of result.children ?? []) out.set(child.id, { x: child.x ?? 0, y: child.y ?? 0 })
  return out
}
